const authorNameWrappers = document.querySelectorAll('.quote-slider__item .quote-slider__name-wrapper')
const authorNames = document.querySelectorAll('.quote-slider__item .quote-slider__name')

function changeFont() {
  authorNameWrappers.forEach((item, index) => {
    if (item.clientWidth - 20 <= authorNames[index].clientWidth) {
      authorNames[index].classList.add('longName')
    } else {
      authorNames[index].classList.remove('longName')
    }
  })
}

changeFont()

$('.quote-slider').slick({
  infinite: false,
  dots: true,
  prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><img src="/assets/img/icons/icon_dark_arrowprev@3x.svg" alt="Previous"/></button>',
  nextArrow: '<button class="slick-next" aria-label="Next" type="button"><img src="/assets/img/icons/icon_dark_arrownext@3x.svg" alt="Next"/></button>',
  responsive: [
    {
      breakpoint: 1105,
      settings: {
        prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><img src="/assets/img/icons/icon_light_arrowleft.svg" alt="Previous"/></button>',
        nextArrow: '<button class="slick-next" aria-label="Next" type="button"><img src="/assets/img/icons/icon_light_arrowright.svg" alt="Next"/></button>',
      }
    }
  ]
})
